<style lang="less">

.gz-file{
	overflow-x:hidden;
    overflow-y:auto;
    background:none;

    .ivu-tooltip-rel{
        height:100%;
    }

    .gz-file-item{
         position: relative;
        width:100%;
        height:40px;
        margin-left:5px;
        margin-top:5px;


        .lf-file-icon{
            width:23px;
            height:20px;
            display: flex;
            align-items: center;;
						justify-content: center;
						position: relative;
            span{
                border:none;
                position: relative;
                bottom:0;
                color:#fff;
                z-index: 10;
                line-height: auto;
                box-shadow: none;
						}

						img{
							width:100%;
						}
        }

        .f-name{
						text-align: left;
						height:30px;
						white-space: nowrap;
						text-overflow: ellipsis;
						display: flex;
						align-items: center;
        }

        .download{
            margin-right:10px;
            color:rgb(29, 157, 248);
            display: flex;
            justify-content: flex-end;
            span:hover{
                color:rgb(96, 180, 240);
                cursor: pointer;
            }

        }
    }
}

.gz-file:hover{
    background: none;
}


.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}

.gz-form-item{
	.ivu-btn{
		span{margin:0;}
	}
}

</style>
<template>
<div class='gz-form-item gz-file' style='border:none;'>

<div class='gz-image-wrapper'>
    <div style="margin:1px 0;color:var(--subtext2)" v-if="all_files.length > 0">已上传 {{ all_files.length }} 个文件</div>
	<draggable v-model="all_files" style='width:100%;' handle=".handle"   v-bind="dragOptions"
    @start="!uploading"
        @end="drag = false;emitChange()">
			  <transition-group type="transition" :name="!drag ? 'flip-list' : null" >
         <template v-for="(f,i) in all_files">

            <div class='gz-file-item flex-wrap flex-between' :key="i" style="flex-wrap:no-wrap;position:relative;margin:0;margin-bottom:5px;">
							<div class="flex-wrap" style="position:relative;z-index:10;width:calc(100% - 100px);flex-wrap:no-wrap;">
								<Icon type="md-menu" style="padding:3px;background:#37d;border-radius:3px;color:#fff;cursor:move;margin-right:5px;" size="10" class="handle"  />
                <div class="flex-wrap flex-center" style="width:25px;height:25px;margin:0 5px;">
                <template v-if="isImage(f.ext)">
                    <img :src='f.url' @click="download(f.url,f.name)" style="width:35px;height:35px;padding:1px;"  />
                </template>
                <template v-else>
                    <div class="flex-wrap flex-center lf-file-icon" @click="download(f.url,f.name)">
                   <img  :src="`https://nbgzfiles-1257839135.cos.ap-shanghai.myqcloud.com/assets/filetype/${f.ext}.png`" />
                    </div>
                </template>
                </div>
                <div class="f-name flex-wrap;" style="position:relative;z-index:10;flex-wrap:no-wrap;flex-grow:1;min-width:100px;">
									<template v-if="editingIndex == i">
										<Input style='margin-right:10px;' v-model="editingName" @ />
										<Button icon="md-checkmark" type='primary' @click="editingIndex=-1;files[i].name=editingName;editingName='';emitChange()" style="margin-right:5px;padding:0;width:40px;height:30px;text-align:center;border-radius:5px !important;overflow:hidden;"></Button>
										<Button icon="md-close" type='error'  @click="editingIndex=-1;editingName=''" style="padding:0;width:40px;height:30px;text-align:center;border-radius:5px !important;overflow:hidden;"></Button>
									</template>
									<template v-else>
										 <span style='flex-grow:1; text-overflow: ellipsis;overflow:hidden;margin-right:5px;'>{{(f.name)}}</span> <span style='padding:1px 5px;background:#aaa;color:#fff;border-radius:5px;margin-left:5px;' v-show='f.loading && f.percent'>{{f.percent}}</span> <Button v-show='f.loading && f.percent' size="small" style="width:auto;height:auto;margin-left:5px;" @click="remove(i)">取消</Button> <Button @click="editingIndex=i;editingName=f.name;" v-if="!f.loading" style='margin-left:10px' size="small" >重命名</Button>
									</template>

                </div>
								</div>
                <div class="download">

                        <Button size="small" @click="s_download(f.url,f.name)" v-if="!f.loading">下载</Button>
                        <Button size="small" @click="remove(i)"  style="margin-left:10px;">移除</Button>
                </div>

                <div v-if="f.loading" style='z-index:0;color:red;position:absolute;height:2px;left:70px;width:400px;background:rgba(33,33,33,0.2);display:flex;align-items:center;bottom:0;color:yellowgreen;text-align:center;max-width:100%;'> <div style='position:absolute;z-index:0;background:linear-gradient(to bottom,#aaff33,darkgreen);position:left:0;top:0;bottom:0;height:100%;overflow:visible;' :style='{width:f.percent}' />


                </div>

            </div>
            </template>
						</transition-group>
	</draggable>
    <div class="flex-wrap flex-col flex-center" style="width:100%;padding:20px 0;border:1px solid var(--border);cursor:pointer;margin-top:10px;"  @dragover.prevent="handleDragOver"
    @drop.prevent="handleDrop" @click="handleClickUpload" v-if="canAddMore">
        <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
        <p>点击或者拖拽文件到这里</p>

        <input type='file' v-show="false" :multiple="isMultiple" :accept="acceptType" ref='file' @change='handleUpload' :index="index" style='width:100%;height:100%;' />
    </div>
     <!-- <div class='gz-image-add' @click="modalFileSelector=true">
         <Icon type='ios-folder-open' />
        <Icon type='md-add' style="position:absolute;right:5px;bottom:5px;background:#fff;font-size:14px;padding:2px;border-radius:2px;" />

    </div> -->


</div>
</div>
</template>
<script>
import draggable from 'vuedraggable';

export default {
  components: {draggable},
  data() {
    return {
      editingIndex: -1,
      editingName: '',
      old_files: [],
      files: [],
      percents: [],
      drag: false,
    };
  },
  mounted() {
    this.getData();
  },
  props: {
    index: {
      type: [Number, String],
    },
    label: {
      type: String,
    },
    value: {
      type: Array | String,
    },
    env: {
      type: Object,
      default: () => ({}),
    },
    parent: {
      type: Object,
    },

    option: {
      type: Object,
      default: ()=>({}),
    },
    axiosServer: {
      type: Object,
    },
  },
  watch: {
    value: {
      handler(v) {
        if (Array.isArray(v)) {
          this.getData();
        } else {
          this.old_files= [];
          this.files = [];
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    all_files: {
      get() {
        return [...this.old_files, ...this.files];
      },
      set() {
        return this.emitChange();
      },

    },
    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost',
        uploading: false,
      };
    },
    canAddMore() {
      if (this.isMultiple) {
        return (this.files.length < this.option.max) || true;
      } else {
        return this.files.length == 0;
      }
    },
    isMultiple() {
      return !this.option.single;
    },
    acceptType() {
      if (this.option.type === 'image') return 'image/*';
      else return '';
    },
  },

  methods: {
    getData() {
      if (Array.isArray(this.value) && this.value.length > 0) {
        this.baseIndex = this.value.length;
        if (this.value.filter((v)=>this.files.findIndex((f)=>f.id == v.file_id)==-1).length > 0) {
          this.$api.afterLogin(()=>{
            this.$api.post(`files/get`, this.value.map((v)=>v.file_id)).then((res)=>{
              const old_files = res.data.data || [];
              old_files.forEach((v)=>{
                const file = this.value.find((t)=>t.file_id == v.id);
                if (file) {
                  v.name = file.name;
                }
              });
              this.old_files = old_files;
            }).catch((e)=>{
              this.Error(e);
            });
          });
        } else {
          this.old_files = [];
        }
      }
    },
    download(url, name) {
      this.DownloadWithName(url, name);
    },
    onUploadProgressList(file) {
      this.$set(file, 'percent', file.percent+'%');
    },
    handleClickUpload() {
      this.$refs.file.click();
    },
    handleDragOver(event) {
      // 添加视觉反馈，例如更改边框颜色
      event.currentTarget.style.border = '1px dashed #3399ff';
    },
    handleDrop(event) {
      event.currentTarget.style.border = '1px solid var(--border)';
      const files = Array.from(event.dataTransfer.files);
      console.log('files:', files);
      this.uploadFiles(files);
    },
    uploadFiles(files) {
      this.uploading = true;
      this.$cos.upload(
          files,
          {
            onPreload: (files)=>{
              console.log('preload:', files);
              this.files = files;
            },
            onFail: (e) => {
              console.log('onFail-called');
              this.Error('上传失败:'+e);
              this.files = [];
              this.uploading = false;
            },
            onProgress: this.onUploadProgressList,
            onSuccessFile: (file, index)=>{
              this.files.splice(this.baseIndex+index, 1, file);
            },
            onSuccess: (files) => {
              console.log('success:', files);
              if (!Array.isArray(files)) throw '文件上传失败';
              this.old_files = this.all_files;
              this.files = [];
              this.emitChange();
              this.uploading = false;
            },
          },
          {coskey: this.$store.getters['session/session'].coskey},
      );
    },
    handleUpload(e) {
      const files = Array.from(this.$refs.file.files);
      this.uploadFiles(files);
    },

    isImage(ext) {
      const imgexts = ['jpg', 'jpeg', 'png', 'gif'];
      return imgexts.includes(ext);
    },

    onAddSelectedFiles(files) {
      this.files = this.files.concat(
          files.filter((f) => this.files.findIndex((v) => v.id == f.id) == -1),
      );

      this.modalFileSelector = false;
    },
    push(u) {
      this.files.push(u);

      return this.files.length - 1;
    },
    cancelUploading(index) {
      if (index == -1) return;
      if (this.files[index] && this.files[index].source) {
        this.files[index].source.cancel('取消上传');
      }
      this.files.splice(index, 1);
    },
    emitChange() {
      this.$emit(
          'input',
          this.old_files.map((v)=>({file_id: v.id, name: v.name})),
      );
    },
    remove(index) {
      if (this.files[index] && this.files[index].source) {
        this.files[index].source.cancel('取消上传');
      }
      this.files.splice(index, 1);
      this.emitChange();
    },
  },
};
</script>
<style lang="less">
.gz-image-wrapper{
    display: flex;
    flex-wrap: wrap;
    margin-top:20px;
    padding-bottom:10px;
    padding-right:10px;
}
.gz-image{
     position: relative;
    display: inline-block;
    background: #fff;
    height:60px;
    color: #ddd;
    text-decoration: none;
    display: flex;
    align-items:center;
    justify-content: center;
    border:1px solid #dfdfdf;
    margin-left:10px;
    margin-top:10px;
    width:60px;
    height:60px;
    overflow: visible;

    cursor: pointer;

    img{
        width:90%;
        height:90%;
        margin:5%;
    }
}

.gz-image-add{

    .gz-image;
    input{
        position: absolute;
         cursor: pointer !important;
        font-size: 100px;
        right: 0;
        top: 0;
        opacity: 0;
        font-size:0;
    }


    i{
        font-size:30px;
        cursor: pointer !important;
        color:#aaa;
    }
}

.gz-image-add:hover{
    cursor: pointer;
    background:yellow;
}

.l-close-btn{
    position: absolute;
    font-size:14px;
    right:-5px;
    top:-5px;
    width:20px;
    height:20px;
    background:darkred;
    border:1px solid #333;
    color:white;
    border-radius: 50%;
    padding:2px;
     display: none;
     z-index:10;
}

.l-close-btn:hover{
    filter:brightness(1.2);
    cursor:pointer;

}

.gz-image:hover{
     background: rgb(246, 255, 208);
     color:#eee;

     .l-close-btn{
        display: block;
    }
}

</style>
